export enum CommunicationAlertCode {
  unread = 'communication.alert.urgent.unread',
}

export enum CommunicationStatus {
  undelivered = 'communication.message.undelivered',
}

export const CommunicationStatusDisplay: Record<CommunicationStatus, string> = {
  [CommunicationStatus.undelivered]: 'Number not whatsapp enabled',
};
